const reportService = require('../../services/report/reportService')

const actions = {
  async generateAppointmentQuantityReport({commit, dispatch}, params) {
    commit('setIsLoading', true)

    try {
      params.report_type = 'APPOINTMENT_QUANTITY'
      const { data } = await reportService.generateAppointmentReport(params)
      return data

    } catch ({ data }) {
      let convertedData = JSON.parse(new TextDecoder().decode(data))
      dispatch('showErrorMessage', convertedData.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async generateAppointmentReport({commit, dispatch}, params) {
    commit('setIsLoading', true)

    try {
      params.report_type = 'APPOINTMENT'
      const { data } = await reportService.generateAppointmentReport(params)
      return data

    } catch ({ data }) {
      let convertedData = JSON.parse(new TextDecoder().decode(data))
      dispatch('showErrorMessage', convertedData.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async generateAppointmentWithQuestionnaireReport({commit, dispatch}, params) {
    commit('setIsLoading', true)

    try {
      params.report_type = 'APPOINTMENT_WITH_QUESTIONNAIRE'
      const { data } = await reportService.generateAppointmentReport(params)
      return data

    } catch ({ data }) {
      let convertedData = JSON.parse(new TextDecoder().decode(data))
      dispatch('showErrorMessage', convertedData.message)
    } finally {
      commit('setIsLoading', false)
    }
  }
}

export default {
  actions
}
